// Bookie · Lavanda Tushi — bridal-shower variant that renders the
// standalone HTML template (Bookie phone-shell, mauve #6B4C8A +
// lavender pastel wash + ivory, Marcellus display + Cormorant
// Garamond italic, dried-lavender corner sprigs in HERO + a tiny
// lavender-bud divider between sections) inside a full-bleed
// iframe. The HTML lives at /templates/bookie-mauve.html.
//
// Bridal shower is an intimate ladies' tea — names is a SINGLE
// bride name, NOT an "A & B" pair. The customizer inside the
// HTML keeps the first token if a caller still passes both.
//
// We pass payload values via the URL because postMessage would
// race the iframe's first paint and the customizer needs to run
// before the IntersectionObserver inside the HTML attaches.
// No audio param — this template is intentionally silent.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-mauve.html";

export function BookieMauveStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) {
    // Bridal shower expects a single bride name. Strip an "& partner"
    // tail if it was supplied by older mock data.
    const bride = t.names.split(/\s*[&,]\s*/)[0]?.trim() || t.names;
    params.set("names", bride);
  }
  if (t.date) {
    // Convert dd.mm.yyyy → ISO yyyy-mm-dd for the customizer.
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Demo / preview surfaces leave ctx.slug undefined.
  if (ctx.slug) params.set("slug", ctx.slug);
  // Cache buster — bump when the static HTML changes.
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  const bride = (t.names || "Lavanda Tushi").split(/\s*[&,]\s*/)[0] || "Lavanda Tushi";
  return (
    <iframe
      src={src}
      title={bride}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#FBF6F2",
      }}
    />
  );
}
